import { useCallback, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./loading";
import moment from 'moment/moment';
import { useAuth } from "../../context/AuthContext";
import { fromConvictionReview, setConvictionReview, setDefaultConvictions, setDefaultDriverData, setDefaultWithdrawals, setErr, setFcwdOnly, setForeignData, setLinkedConvictions, setNewUser } from "../../utils/data";
import { countryOptions } from "../../utils/countryOptions";

//const user = 'admin'; // Example user, replace with actual user logic


function ConvictionReview() {
    const [tableData, setTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showNoRecords, setShowNoRecords] = useState(false);
    const [pendingDelete, setPendingDelete] = useState([]);
    const {source, userState, email, roles, token} = useAuth();
    const defined = (v) => v !== undefined && v !== null && v !== "";

    let user = ""

    // TODO: change once we have real user data

    /*
    const requestBody = {
        Source:{DataSource: source},
        ...(jurisdiction && {Jurisdiction: jurisdiction})
    };

    */

    console.log(email)


    const requestBody = {
       "Header": {
        "Metadata": {
            "UserID": email //to be replaced with db email
        }
    },
    "Body": {
        "Source":{
            "DataSource": source,
        },
        "Jurisdiction": userState,
    }
}
    
    const navigate = useNavigate();
    const fetchData = useCallback(async () => {
    setSelectedRows([]);
    setLoading(true);
    setShowModal(false);
    setPendingDelete([]);
    setConvictionReview(false);
    setNewUser(false);
    setDefaultConvictions([]);
    setDefaultDriverData({});
    setForeignData({});
    setDefaultWithdrawals([]);
    setLinkedConvictions([]);
    setErr('');
    
    if(email === undefined){
      return;
    }

    try {
        const response = await fetch(`/api/reviews`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(requestBody),
        });
        const result = await response.json();
        setTableData(result?.Records ?? []);
    } catch (e) {
        console.error("Error fetching data:", e);
        setTableData([]);
    } finally {
        setLoading(false);
    }
    }, [email]);

    useEffect(() => { fetchData(); }, [fetchData]);

    const deleteRows = async (ids) => {
        const deleteRequestBody = {
            Header: {
                Metadata: {
                    UserID: email //to be replaced with db email
                }
            },
            Body: {
              Source:{DataSource: source},
              ReviewIds:ids,
              UserID: email
            }
        }
        await fetch(`/api/delete/reviews`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(deleteRequestBody),
        })
        .then(response => response.json())
        .then(data => {
            console.log('Delete Response:', data);
        })
        .catch(error => {
            console.error('Error deleting data:', error);
        });
    }
    const deleteSelected = async () => {
        if (selectedRows.length === 0){
          setShowNoRecords(true);
          return;
        }
        setPendingDelete(selectedRows);
        setShowModal(true);
    };

    const deleteRow = async (id) => {
        setPendingDelete([id]);
        setShowModal(true);
    };
    const handleConfirmDelete = async () => {
        try {
            await deleteRows(pendingDelete);
        } catch (e) {
        console.error("Error deleting:", e);
        } finally {
        fetchData();
        }
    };
    const editDriver = (driverState, driverLicense) => {
      setConvictionReview(true);
      const isFCWD = countryOptions["US"].some(c => c.code === driverState) || countryOptions["OTH"].some(c => c.code === driverState);
      setFcwdOnly(isFCWD);
      navigate(`/driverdetails/${driverState}/${encodeURIComponent(driverLicense)}/`);
    }

    if(loading){
        return(<>
        <Loading />
        </>)
    }
    if(tableData.length === 0){
        return(<>
        <div className="App" id="table">
            <h3>No Records Found</h3>
        </div>
        </>)
    }
  return (
    <div className=" App table-scroll-container" id="table">
        <table class="table table-striped table-bordered">
        <thead class="table-header sticky-header">
            <tr>
            <th scope="col">Action</th>
            <th scope="col">Select</th>
            <th scope="col">Driver State</th>
            <th scope="col">Driver License</th>
            {source === 'HelpDesk' && <th scope="col">Data Origin FCWD</th>}
            <th scope="col">Conviction ID</th>
            <th scope="col">Withdrawal ID</th>
            {source === 'HelpDesk' && <th scope="col">Conviction Withdrawal Code</th>}
            <th scope="col">Conviction Review Reason</th>
            {source === 'HelpDesk' && <th scope="col">Jurisdiction Data</th>}
            {source === 'HelpDesk' && <th scope="col">Foreign Data</th>}
            <th scope="col">Review Received Date</th>
            </tr>
        </thead>
        <tbody>
        {tableData.map((row, index) => (
            <tr>
            <td>
                <div style={{"display":"ruby-text"}}>
                    <button className="btn btn-outline" onClick={() => editDriver(row.driver_state, row.driver_license_number)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg></button> | <button className="btn btn-outline" onClick={() => deleteRow(row.review_id)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                    </svg></button>
                </div>
            </td>
            <td><input style={{width:'1em', height:'1em'}} type="checkbox" aria-label="Checkbox for following text input" checked={selectedRows.includes(row.review_id)} 
            onChange={e => {
            if (e.target.checked) {
                setSelectedRows([...selectedRows, row.review_id]);
            } else {
                setSelectedRows(selectedRows.filter(id => id !== row.review_id));
            }
            }}/></td>
            <td>{row.driver_state}</td>
            <td>{row.driver_license_number}</td>
            {source === 'HelpDesk' && <td>{row.data_origin_fcwd}</td>}
            <td>{row.conviction_id}</td>
            <td>{row.withdrawal_id}</td>
            {source === 'HelpDesk' && <td>{row.conviction_withdrawal_code}</td>}
            <td>{row.conviction_review_reason}</td>
            {source === 'HelpDesk' && <td>{row.jurisdiction_data}</td>}
            {source === 'HelpDesk' && <td>{row.foreign_data}</td>}
            <td>{moment(row.review_received_date).format("MM-DD-YYYY h:mm:ss A")}</td>
            </tr>
        ))}
        </tbody>
    </table>
    <button className="btn btn-danger sticky-bottom" onClick={deleteSelected}> Delete Selected</button>
     {/* Bootstrap Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete the review(s)
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showNoRecords && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">None Selected</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowNoRecords(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  No rows selected. Please select at least one conviction review record you wish to delete.
                </p>
              </div>
              {/* <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowNoRecords(false)}
                >
                  Okay
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default ConvictionReview;